import React, { useEffect } from "react";
import "./login.scss";
import Logo from "../../images/logo.png";
import Capture from "../../images/Capture.png";
import Peerlogo from "../../images/logo-peer-ease.png";
import IntegraLogo from "../../images/integra-logo.png";

function Login() {
  useEffect(() => {
    const bodyClassName = process.env.REACT_APP_BODY_CLASS || "";
    document.querySelector("body")?.classList.add(bodyClassName);
  }, []);

  return (
    <div className="login-page">
      <div className="left-side">
        <div className="logo-top">
          <img src={Logo} alt="logo" />
        </div>
        <div className="capture">
          <h1>Peer Review System</h1>
          <div>
            <img src={Capture} alt="peerreview" className="no-demo" />
            <img src={Peerlogo} alt="peerease" className="demo" />
          </div>
        </div>
        <div className="left-side-bottom">
          <p>
            Powered by <img src={IntegraLogo} alt="integra-logo" /> | All Rights Reserved
          </p>
        </div>
      </div>

      <div className="right-side">
        <div className="right-side-main">
          <div className="right-side-inner text-center">
            <h1 style={{ color: "#3F52A3" }}>Important Notice: PeerEase URL Updated</h1>
            <p style={{ fontSize: "16px", marginTop: "20px", color: "#555" }}>
             Please use the new URL below to continue your work:
            </p>
            <div style={{ marginTop: "40px" }}>
              <p style={{ fontWeight: "bold", color: "#3F52A3" }}>
                URL: <a href="https://peerease.integra.co.in/login" style={{ color: "#3F52A3" }}>
                  https://peerease.integra.co.in/login
                </a>
              </p>
              <p style={{ color: "#777" }}>Thanks for staying with us!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
